<mobile-page-content [fullPageWidth]="true">
    <app-mobile-header header [hasSideMenu]="true"></app-mobile-header>

    <app-mobile-side-menu right-menu></app-mobile-side-menu>

      <app-chat-discussion-list [mobileDisplay]="true"
                                [organization]="organization"
                                [athleteUser]="athleteUser"
                                [discussionContainer]="discussionRefs">
      </app-chat-discussion-list>

      <ng-template #discussionMobileRef></ng-template>
</mobile-page-content>

